export default __webpack_public_path__ + "static/media/ZeniqNano.ed62c9c1.ttf";